module.exports = __webpack_public_path__ + "img/menu.c552bf97.png";